import Typography from "typography"

const typography = new Typography({
  baseFontSize: "18px",
  baseLineHeight: 1.666,
  headerFontFamily: ["Lato"],
  bodyFontFamily: ["Lato"],
  googleFonts: [
    {
      name: 'Lato',
      styles: [
        '400',
        '500',
        '600',
        '700',
      ],
    }
  ]
})

typography.injectStyles()
export default typography
/*
import Typography from 'typography'
import sternGroveTheme from 'typography-theme-stern-grove'

const typography = new Typography(sternGroveTheme)

export default typography

  */
